export default __webpack_public_path__ + "static/media/0xdf7837de1f2fa4631d716cf2502f8b230f1dcc32.c5c078c4.webp";